module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>ToggleButton is a button-like component that has two states: pressed and\nunpressed.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<p><code>`</code></p>\n<p><ToggleButton label=\"Toggle me\" iconType=\"add\" />\n<code></code></p>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/ToggleButton/README.md
// module id = 408
// module chunks = 0